export { default as DiagnosticsPane } from './components/DiagnosticsPane';
export { default as FeatureFlagsPane } from './components/FeatureFlagsPane';
export { default as HelpPane } from './components/HelpPane';
export { default as MiniMavenPane } from './components/MiniMavenPane';
export { default as MeCardPane } from './components/MeCardPane';
export { default as SettingsPane } from './components/SettingsPane';
export { default as FeedbackPane } from './components/FeedbackPane';
export { default as WafflePane } from './components/WafflePane';
export { default as GetStartedPane } from './components/GetStartedPane';
export { default as WhatsNewPane } from './components/WhatsNewPane';
export { default as TodoPane } from './components/TodoPane';
export { default as TimePanelPane } from './components/TimePanelPane';
export { default as FeatureFlagsHeader } from './components/FeatureFlags/FeatureFlagsHeader';
export { default as FeatureFlagsList } from './components/FeatureFlags/FeatureFlagsList';
export { default as ActivityFeedPane } from './components/ActivityFeedPane';
export { default as launchHelpPane } from './actions/launchHelpPane';
export { showTodoPanelWithSubject } from './actions/showTodoPanelAction';
export { default as toggleGetStartedPane } from './actions/toggleGetStartedPane';

import './orchestrators/featureFlagsPaneOrchestrators';
import './mutators/featureFlagsPaneMutators';
import './orchestrators/showTodoPanelWithSubjectOrchestrator';
import './orchestrators/tryTodoPanelOrchestrator';

// Register owa-time-panel's orchestrator to launch the timepanel before we start the header pane
import 'owa-time-panel/lib/orchestrators/timePanelBootstrapOrchestrators';
